import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/BasicLayout/index.vue'

/** 是否为本地开发或测试环境 */
const isLocalOrTest = import.meta.env.DEV || import.meta.env.VITE_BUILD_ENV === 'staging'

/** 仅本地 dev 与 测试环境 可用，build 时由 Vite 静态消除 */
const localOrTestOnlyRoutes: RouteRecordRaw[] = isLocalOrTest
  ? [
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login/index.vue'),
        meta: {
          hideInMenu: true,
          hideInTab: true
        }
      }
    ]
  : []

const basicRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    // permission.ts 控制路由重定向，这里默认展示空页面
    component: Layout,
    meta: {
      title: 'Welcome',
      hideInMenu: true,
      hideInTab: true
    }
  },
  ...localOrTestOnlyRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/layouts/NotFound.vue'),
    meta: {
      title: '404',
      hideInMenu: true,
      hideInTab: true
    }
  }
]

export { basicRoutes }
